module.exports = __webpack_public_path__ + "static/media/wonder-woman.801c4751.png";